import { Component, ContentChildren, ElementRef, QueryList, TemplateRef } from '@angular/core';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'mpro-accordion2',
  templateUrl: './accordion2.component.html',
  styleUrls: ['./accordion2.component.scss']
})
export class AccordionComponent2 {
  faAngleDown = faAngleDown;

  @ContentChildren('panel') public panels: QueryList<ElementRef>;
  @ContentChildren('header', { read: TemplateRef, descendants: true }) public headers: QueryList<TemplateRef<any>>;
  @ContentChildren('content', { read: TemplateRef, descendants: true }) public contents: QueryList<TemplateRef<any>>;
}
